import React, { Component } from 'react';
import { getHospitais } from '../../Libs/hospital';
import SelectIcon from '../../gb-components/SelectIcon';
import IconHospital from '../../assets/svg/ic-medicine-helicopter.svg';


export default class DropDownHospital extends Component {

  state = {
    hospital: null
  };
  componentDidMount() {
    getHospitais()
      .then(hospital => {
          this.setState({ hospital });
      })
      .catch(error => {
      });
  }

  render() {
    return (
      <SelectIcon
        placeholder={this.props.placeholder ? this.props.placeholder : "Hospital"}
        data={this.state.hospital ? this.state.hospital.map(it => { return { id: it.id, descricao: it.hospital } }) : []}
        value={this.props.hospital}
        icon={IconHospital}
        change={event =>
          this.props.change(event)
        }
        style={this.props.style}
        theme={this.props.theme}
        label={this.props.label}
        opcional={this.props.opcional}
      />
    );
  }
}
